<template>
    <div data-aos="fade-up">
        <div class="row no-gutters px-md-0 px-2">
            <div class="col-md-10 offset-md-1 box px-md-4 pt-md-3 mt-md-5 mt-4  border-line"
                style="border-radius:10px">
                <div class="row no-gutters main-window mt-md-3" style="border-radius: 13px;position: relative;">
                    <div class="col-12">
                        <div class="window-header p-1 rounded">
                            <i class="material-icons text-pink ml-2 top-botttom-aling">circle</i>
                            <i class="material-icons text-warning ml-2 top-botttom-aling">circle</i>
                            <i class="material-icons text-danger ml-2 top-botttom-aling">circle</i>

                            <div class="float-right search-bottom mt-2 ml-1 mr-1">
                                <span class="material-icons ml-2 text-info" style="font-size:20px">search</span>
                            </div>
                            <div class="float-right search mt-2">
                                <span class="material-icons ml-2 text-warning" style="font-size:20px">star_border</span>
                                <span class="material-icons ml-2 text-warning" style="font-size:20px">star_border</span>
                                <span class="material-icons ml-2 text-warning" style="font-size:20px">star_border</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 pl-4 pr-4 pt-4">
                        <h5 class="text-warning let-write silkscreen-regular">Let's-Write /&gt;</h5>
                        <div class="block-one mt-2"></div>
                    </div>
                    <div class="col-12" v-if="getMyToolsApiErrStatus"> <!--if error exist-->
                        <loading-fail redirect="/" />
                    </div>
                    <div  v-else-if="getMyToolsApiPendingStatus" class="col-12 mt-5"> <!--check pending status-->
                        <Pending />
                    </div>
                    <div class="col-12 row no-gutters pb-5  ">
                        <div v-for="lang in getLangs" :key="lang.key"
                            class="col-md-3 col-6 text-light text-center mt-3 mt-md-4 pl-md-5 px-2 pr-md-5 hover pr-1"
                            id="mouseMoveAni" data-value="2" >
                            <div class="rounded p-2 " style="background-color: #b38316"><strong>{{ lang.lang
                            }}</strong></div>
                        </div>
                    </div>
                    <!-- virtual code line -->
                    <div class="col-12  w-100 pl-3 pr-3 pb-5" style="position: absolute;z-index: -1000;top:100px">
                        <div class="code-line-one bg-danger mt-2  ml-3"></div>
                        <div class="code-line-two bg-info mt-4 ml-4"></div>
                        <div class="code-line-three bg-light mt-3 ml-5"></div>
                        <div class="code-line-four bg-secondary mt-3 ml-4"></div>
                        <div class="code-line-five bg-success mt-3 ml-3"></div>
                        <div class="code-line-two bg-info mt-3 ml-4"></div>
                        <div class="code-line-four bg-secondary mt-3 ml-4"></div>
                        <div class="code-line-one bg-danger mt-3  ml-3"></div>
                    </div>
                    <!-- rocket animation -->
                    <div class="col-md-4 pt-3 pb-5">
                        <img :src="host + 'mongodb.png'" class="mongodb-logo" />
                        <RocketAnimation />
                    </div>
                </div>
                <!-- circle -->
                <div class="text-center">
                    <span class="material-icons text-warning text-center mt-2 rotate">lens</span>
                </div>
            </div>
            <!-- foot1 -->
            <div class="col-4 offset-4 pl-md-5 pr-md-5">
                <div class="computer-foot box ml-md-5 mr-md-5"></div>
            </div>
            <!-- foot2 -->
            <div class="col-8 col-md-4 offset-md-4 computer-foot2 offset-2 box"></div>
            <div class="col-md-1">
                <img src="https://raw.githubusercontent.com/ShineShineDev/ShineShineDev/refs/heads/main/imgs/mongodb.png" class="mysql-img mt-2" />
            </div>
        </div>
    </div>
</template>
<script>
import LoadingFail from "./../components/LoadingFail.vue";
import Pending from "./../components/Pending.vue";
import RocketAnimation from "./../components/RocketAnimation.vue";
import {InitBrowserAgent} from "./../services/detech-visitors.js";
export default {
    name: "Skills",
    components: { Pending, LoadingFail, RocketAnimation },
    created() {
        const {browser,language,platform,innerWidth,innerHeight,URL,visitor_generated__id,is_new_visitor,outerWidth,outerHeight,referrer} = InitBrowserAgent(); 
        this.$store.dispatch('initApi', { url: 'https://bot.okjapanstore.com/api/tg/notify', method: 'POST', data: { Noti: 'Alert',URL,browser,language,platform,innerWidth,innerHeight,visitor_generated__id , is_new_visitor,innerWidth,innerHeight,outerWidth,outerHeight,referrer} });
        this.$store.dispatch('initMyToolsApi'); //inti firebase api
    },
    data() {
		return {
			host: process.env.VUE_APP_HOST,
		};
	},
    computed: {
        getLangs() {
            let langs = this.$store.getters.getLangs; // get langs from vuex
            //console.log(langs);
            return langs.sort((a, b) => a.priority - b.priority); //return sorted array by priority number
        },
        getMyToolsApiErrStatus() {
            return this.$store.getters.getMyToolsApiErrStatus //return sorted array by priority number
        },
        getMyToolsApiPendingStatus() {
            return this.$store.getters.getMyToolsApiPendingStatus // get pending status
        }
    },
}
</script>

<style scoped>
.jquery-img {
    transform: rotate(20deg);
    width: 45px;
    position: relative;
    left: 80%;
}

@import url('https://fonts.googleapis.com/css2?family=Silkscreen:wght@400;700&display=swap');

.silkscreen-regular {
    font-family: "Silkscreen", sans-serif;
    font-weight: 400;
    font-style: normal;
}

.text-pink {
    color: pink;
}

.shine-divider {
    margin-top: 5px;
    margin-bottom: 3px;
    border: 0px;
    height: 3px;
    background: linear-gradient(to right, rgba(157, 157, 157, 0), #ec4e10, rgba(0, 0, 0, 0));
    background-size: 200% 100%;
    animation: shineAnimation 1.5s infinite alternate;
}

.border-line {
    border-radius: 50%;
    border-left: 2px solid #FF4A01;
    border-right: 2px solid #FF4A01;
    border-radius: 0 0 10px 10px;
}

.custom-bg-color {
    background-color: #ff4a01;
}

@keyframes shineAnimation {
    0% {
        background-position: 100% 50%;
    }

    100% {
        background-position: 0 50%;
    }
}

.main-window {
    background: rgba(0, 0, 0, 0.2);
    border: 2px solid rgba(255, 217, 217, 0.2);
}

.window-header {
    background: rgba(255, 255, 255, 0.4);
    border-top: 2px solid rgba(255, 217, 217, 0.2);
    border-bottom: 2px solid rgba(255, 217, 217, 0.2);
}

.window-header>.search {
    background: rgba(0, 0, 0, 0.2);
    width: 40%;
    height: 20px;
    border-radius: 10px;
}

.code-line-one {
    background: rgba(0, 0, 0, 0.1);
    width: 60%;
    height: 6px;
    border-radius: 5px;
    opacity: 0.1;
}

.code-line-two {
    background: rgba(0, 0, 0, 0.1);
    width: 46%;
    height: 6px;
    border-radius: 5px;
    opacity: 0.1;
}

.code-line-four {
    background: rgba(0, 0, 0, 0.1);
    width: 41%;
    height: 6px;
    border-radius: 5px;
    opacity: 0.1;
}

.code-line-three {
    background: rgba(0, 0, 0, 0.1);
    width: 74%;
    height: 6px;
    border-radius: 5px;
    opacity: 0.1;
}

.code-line-five {
    background: rgba(0, 0, 0, 0.1);
    width: 30%;
    height: 6px;
    border-radius: 5px;
    opacity: 0.1;
}

.search-bottom {
    background: rgba(0, 0, 0, 0.2);
    width: 30px;
    height: 20px;
    border-radius: 10px;
}

.computer-foot {
    background: rgba(255, 255, 255, 0.4);
    height: 100px;
}

.computer-foot2 {
    height: 30px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 4px;
}

.laravel-logo {
    transform: rotate(20deg);
    width: 50px;
    position: relative;
    left: 24%;
}

.mongodb-logo {
    transform: rotate(20deg);
    width: 70px;
    position: relative;
    top: -20px;
    left: 24%;
}

.mysql-img {
    transform: rotate(20deg);
    width: 30px;
    position: relative;
    left: 84%;
}
</style>

